import type { VideoCategoryShallow } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import Link from "next/link";
import { useMemo } from "react";

import Accordion from "~/components/Accordion";
import { getCategoryPath } from "~/lib/videos.lib";

interface VideosCatalogueItemProps {
	category: VideoCategoryShallow;
	shallowCategories: VideoCategoryShallow[];
	parentSlugs: string[];
}

const VideosCatalogueItem = ({
	category,
	shallowCategories,
	parentSlugs,
}: VideosCatalogueItemProps) => {
	const { slugs = [] } = useRouter()?.query as {
		slugs?: string[];
	};
	const isSelected = slugs[slugs.length - 1] === category.slug;
	const isOpen = slugs.some((slug) => slug === category.slug);
	const hasChildren = !!category.subCategories?.length;

	const path = useMemo(
		() => getCategoryPath(shallowCategories, category, parentSlugs),
		[shallowCategories, category, parentSlugs],
	);

	return (
		<div>
			<Link
				href={
					isSelected
						? path.length > 1
							? `/videos/categories/${path.slice(0, -1).join("/")}`
							: "/videos"
						: `/videos/categories/${path.join("/")}`
				}
			>
				<Accordion.Button
					isOpen={isOpen}
					isSelected={isSelected}
					hasChildren={hasChildren}
				>
					{category.title}
				</Accordion.Button>
			</Link>
			<Accordion.Panel isOpen={!!category.subCategories?.length && isOpen}>
				<div className="flex flex-col gap-1.5">
					{category.subCategories?.map((subcategory) => (
						<VideosCatalogueItem
							key={subcategory.slug}
							category={subcategory}
							shallowCategories={shallowCategories}
							parentSlugs={[...parentSlugs, category.slug]}
						/>
					))}
				</div>
			</Accordion.Panel>
		</div>
	);
};

export default VideosCatalogueItem;
